import React, {Component} from 'react';
import {connect} from "react-redux";
import {bindActionCreators} from "redux";

import * as Actions from "../../../../../store/modules/category";
import * as func from "../../../../../utils/functions";
import Category from '../../../../../components/admin/type/old_category'
import Category2 from "../../../../../components/admin/type/category";

class JCRCategories extends Component {
	constructor(props) {
		super(props);

		this.state = {
			title: 'JCR Category',
			type: 'jcr_category'
		}
	}

	render() {
		return (
			<Category2
				title={this.state.title}
				type={this.state.type}
			/>
		)
	}
}

// export default Code;

export default connect(
	(state) => ({
		param: state.category.param ? state.category.param : {},
		category: state.category.category ? state.category.category : [],
	}),
	(dispatch) => ({
		dataActions: bindActionCreators(Actions, dispatch)
	}),
)(JCRCategories)